module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_7.2441cf438c8352c94a2d1eb96d82362a.png";